// extracted by mini-css-extract-plugin
module.exports = {"root":"SearchButton_root__bDVIq","searchButton":"SearchButton_searchButton__i9WXW"};